<template>
    <div class="modal fade" tabindex="-1" role="dialog" style="z-index: 1060" id="AlertaModal" data-backdrop="static" aria-labelledby="gridSystemModalLabel">
        <div class="modal-dialog modal-lg" role="document" style="width: calc(100vw - 20px); height: calc(100vh - 100px)">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h4 class="modal-title" id="gridSystemModalLabel">Atendimento de Evento</h4>
                </div>
                <div class="modal-body" v-if="id">
                    <alerta :id="id" @saved="saved()"></alerta>
                </div>
            </div><!-- /.modal-content -->
        </div><!-- /.modal-dialog -->
    </div><!-- /.modal -->
</template>

<style scoped>
    .modal-header .close {
        margin-top: 2px;
    }
    .modal .close, .modal .modal-title {
        color: white;
    }
    .close {
        opacity: 1;
    }
</style>

<script>

    import Alerta from '../alertas/Alerta';

    export default {
        ID: "#AlertaModal",

        props: {
            id: null
        },

        components: {
            Alerta
        },

        mounted () {
            $("#AlertaModal").on('hide.bs.modal', (event) => {
                this.$emit("closed")
            });
        },

        methods: {
            saved () {
                this.$emit("saved");
                $("#AlertaModal").modal('hide');
            }
        }
    }

</script>
